import React from 'react';
import { Container, Section } from '../ui/Section';
import { Wordmark } from '../brand/Wordmark';
import { DoodleBurst } from '../brand/Doodles';
const pillars = [{
  title: 'Bring In',
  copy: 'Welcome students and help them encounter the Gospel in a genuine Christian community.'
}, {
  title: 'Build Up',
  copy: 'Help students grow in faith, friendship, service, and leadership.'
}, {
  title: 'Send Out',
  copy: 'Equip students to live out their faith and serve on campus and beyond.'
}];
export function Mission() {
  return <Section className="on-dark relative overflow-hidden bg-brand-navy py-16 text-white sm:py-24" labelledBy="mission-heading" data-id="element-184" data-mp="32xinzdh5rbg7">
      <DoodleBurst className="pointer-events-none absolute right-8 top-10 h-12 w-12 opacity-80 sm:h-16 sm:w-16" color="var(--bcm-yellow)" data-id="element-185" data-mp="3cowl5elmzz66" />
      <Container data-id="element-186" data-mp="3lpupjxzzm8pa">
        <p className="font-meta text-xs font-semibold uppercase tracking-[0.2em] text-brand-blue" data-id="element-187" data-mp="3lqct7fozbp78">
          Our Mission
        </p>
        <h2 id="mission-heading" className="mt-4 max-w-3xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-6xl" data-id="element-188" data-mp="3k23zorgyd0xn">
          Bring in. Build up. Send out.
        </h2>

        <ul className="mt-12 grid gap-8 sm:grid-cols-3 sm:gap-10" data-id="element-189" data-mp="3u130xoze1uam">
          {pillars.map(pillar => <li key={pillar.title} className="border-t-4 border-brand-yellow pt-5" data-id="element-190" data-mp="1t39ifkulnap">
              <h3 className="font-display text-2xl font-bold text-brand-blue" data-id="element-191" data-mp="6u0okjaka17z">{pillar.title}</h3>
              <p className="mt-2 font-sans text-[16px] leading-relaxed text-white" data-id="element-192" data-mp="brizgf852qim">
                {pillar.copy}
              </p>
            </li>)}
        </ul>

        <div className="mt-14" data-id="element-193" data-mp="li58trp9iksv">
          <Wordmark variant="white" className="h-10" data-id="element-194" data-mp="ll9k1915agt1" />
        </div>
      </Container>
    </Section>;
}